import { useEffect, useState } from 'react';
import CommonService from '../services/common.service';

/**
 * Fetches `/master/condition-facility` → `condition_facility` table
 * (condition_facility_id, condition_facility).
 * @param {boolean} enabled - when false, skips the request
 */
export function useMasterConditionFacility(enabled = true) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(!!enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setList([]);
      setLoading(false);
      setError(null);
      return undefined;
    }
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const response = await CommonService.get('/master/condition-facility');
        if (cancelled) return;
        const raw = response?.data;
        const rows = Array.isArray(raw) ? raw : [];
        setList(rows);
      } catch (e) {
        if (!cancelled) {
          setError(e);
          setList([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { list, loading, error };
}
